import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
    async getFusionPools(context) {
        try {
            let resp = await axios.get(Constants.poolsUrl);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getFusionPools][Store][Error occured while getting pools--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                }
                else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updateDefaultPool(context, payload = {}) {
        try {
          let resp = await axios.put(`${Constants.poolsUrl}/${payload._id}`, payload);
          if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updateDefaultPool][Store][Error occured while updating default pool--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }else if (error.response.status == 405){
              return {statusCode:error.response.status,message:"failed to update default pool"}
            } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async getPoolDevices(context) {
        try {
            let resp = await axios.get(Constants.poolDevicesUrl);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getPoolDevices][Store][Error occured while getting pool devices--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                }
                else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async updatePoolPriority(context, payload = {}) {
        try {
          let resp = await axios.put(`${Constants.poolDevicesUrl}/priority`, payload);
          if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[updatePoolPriority][Store][Error occured while updating default pool--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }else if (error.response.status == 405){
              return {statusCode:error.response.status,message:"failed to update default pool"}
            } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async createPoolGroup(context, payload = {}) {
        try {
          let resp = await axios.post(`${Constants.poolsUrl}/groups`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
              `[createPoolGroup][Store][Bin add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
          } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
        } catch (error) {
          console.error(
            `[createPoolGroup][Store][Error occured while createPoolGroup--->${error}]`
          );
          if (error.response) {
            if (error.response.status == 401){
              return context.dispatch("users/logOutFromServer", {},{root:true})
            }
            else {
              error.response.data.statusCode = error.response.status
              return error.response.data
            }
          }
          return {}
        }
      },

      async getAllPoolGroups(context) {
        try {
            let resp = await axios.get(`${Constants.poolsUrl}/groups`);
            if (Constants.acceptedStatusCodes.includes(resp.status)) {
                resp.data.statusCode = resp.status
                return resp.data;
            } else {
                throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
            }
        } catch (error) {
            console.error(
                `[getAllPoolGroups][Store][Error occured while getting pools--->${error}]`
            );
            if (error.response) {
                if (error.response.status == 401) {
                    return context.dispatch("users/logOutFromServer", {}, { root: true })
                }
                else {
                    error.response.data.statusCode = error.response.status
                    return error.response.data
                }
            }
            return {}
        }
    },

    async editPoolGroup(context, payload = {}) {
      try {
        let resp = await axios.put(`${Constants.poolsUrl}/groups/${payload.id}`, payload);
        if (resp.status == 200) {
          resp.data.statusCode = resp.status
          return resp.data;
        } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
      } catch (error) {
        console.error(
          `[editPoolGroup][Store][Error occured while updating default pool--->${error}]`
        );
        if (error.response) {
          if (error.response.status == 401){
            return context.dispatch("users/logOutFromServer", {},{root:true})
          }else if (error.response.status == 405){
            return {statusCode:error.response.status,message:"failed to update default pool"}
          } else {
            error.response.data.statusCode = error.response.status
            return error.response.data
          }
        }
        return {}
      }
    },

    async deletePoolGroup(context, payload = {}) {  
      try {
          let resp = await axios.delete(`${Constants.poolsUrl}/groups/${payload.id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              console.log(
                  `[deletePoolGroup][Store][Tag Delete resp-->${resp.status}]`
              );
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
      } catch (error) {
          console.error(
              `[deletePoolGroup][Store][Error occured while deleting User--->${error}]`
          );
          if (error.response) {
              if (error.response.status == 401) {
                  return context.dispatch("users/logOutFromServer", {}, { root: true })
              } else {
                  error.response.data.statusCode = error.response.status
                  return error.response.data
              }
          }
          return {}
      }
  
    },

    async createCatalogPoolMapper(context, payload = {}) {
      try {
        let resp = await axios.post(`${Constants.catalogPoolMapper}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
          console.log(
            `[createPoolGroup][Store][Bin add resp-->${resp.status}]`
          );
          resp.data.statusCode = resp.status
          return resp.data;
        } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
      } catch (error) {
        console.error(
          `[createPoolGroup][Store][Error occured while createPoolGroup--->${error}]`
        );
        if (error.response) {
          if (error.response.status == 401){
            return context.dispatch("users/logOutFromServer", {},{root:true})
          }
          else {
            error.response.data.statusCode = error.response.status
            return error.response.data
          }
        }
        return {}
      }
    },

    async getCatalogPoolMapper(context) {
      try {
          let resp = await axios.get(`${Constants.catalogPoolMapper}`);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
      } catch (error) {
          console.error(
              `[getCatalogPoolMapper][Store][Error occured while getting pools--->${error}]`
          );
          if (error.response) {
              if (error.response.status == 401) {
                  return context.dispatch("users/logOutFromServer", {}, { root: true })
              }
              else {
                  error.response.data.statusCode = error.response.status
                  return error.response.data
              }
          }
          return {}
      }
  },

  async editCatalogPoolMapper(context, payload = {}) {
    try {
      let resp = await axios.put(`${Constants.catalogPoolMapper}/${payload.id}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[editCatalogPoolMapper][Store][Error occured while updating default pool--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update default pool"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteCatalogPoolMapper(context, payload = {}) {  
    try {
        let resp = await axios.delete(`${Constants.catalogPoolMapper}/${payload.id}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[deleteCatalogPoolMapper][Store][Tag Delete resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[deleteCatalogPoolMapper][Store][Error occured while deleting User--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },
  

};
